/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationType } from '../../models/application-type';
import { EntityParameterDto } from '../../models/entity-parameter-dto';
import { EntityType } from '../../models/entity-type';

export interface EntityParameterGetAsDto$Params {

/**
 * Parameter key
 */
  entityId?: string;

/**
 * parameter name
 */
  parameterName?: string;

/**
 * Entity type
 */
  entityType?: EntityType;

/**
 * Application type
 */
  applicationType?: ApplicationType;
}

export function entityParameterGetAsDto(http: HttpClient, rootUrl: string, params?: EntityParameterGetAsDto$Params, context?: HttpContext): Observable<StrictHttpResponse<EntityParameterDto>> {
  const rb = new RequestBuilder(rootUrl, entityParameterGetAsDto.PATH, 'get');
  if (params) {
    rb.query('entityId', params.entityId, {});
    rb.query('parameterName', params.parameterName, {});
    rb.query('entityType', params.entityType, {});
    rb.query('applicationType', params.applicationType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EntityParameterDto>;
    })
  );
}

entityParameterGetAsDto.PATH = '/v1/EntityParameter/GetAsDTO';
